import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
export function useIsClipReviewer() {
    const { groups } = useGroups();
    return {
        isClipReviewer: groups.includes(AuthGroup.ClipReviewer),
    };
}
